import { render, staticRenderFns } from "./warningMsg.vue?vue&type=template&id=5252892f&scoped=true"
import script from "./warningMsg.vue?vue&type=script&lang=js"
export * from "./warningMsg.vue?vue&type=script&lang=js"
import style0 from "./warningMsg.vue?vue&type=style&index=0&id=5252892f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252892f",
  null
  
)

export default component.exports